// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from checkbox.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function CheckboxIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="-4 -4 39 39"
      aria-hidden="true"
      {...props}
    >
      <rect
        class="hyp-svg-checkbox--background"
        width="35"
        height="35"
        x="-2"
        y="-2"
        stroke="currentColor"
        fill="none"
        stroke-width="3"
        rx="5"
        ry="5"
      />
      <path
        class="hyp-svg-checkbox--checkmark"
        stroke="transparent"
        stroke-width="5"
        fill="none"
        d="m4 14 8 9L28 5"
      />
    </svg>
  );
}
